import { Layout as AntdLayout } from 'antd';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import Breadcrumb from './Breadcrumb';
import CenteredLoader from './CenteredLoader';
import PageTitle from './PageTitle';
import Sidebar from './Sidebar';

export default function Layout() {
    return (
        <AntdLayout
            hasSider
            className="h-screen"
        >
            <PageTitle />
            <Sidebar />
            <AntdLayout className="min-h-0">
                <AntdLayout.Content className="relative flex min-h-0 flex-col overflow-hidden">
                    <div className="shrink-0">
                        <Breadcrumb />
                    </div>
                    <div className="min-h-0 flex-1 overflow-y-auto">
                        <Suspense fallback={<CenteredLoader />}>
                            <Outlet />
                        </Suspense>
                    </div>
                </AntdLayout.Content>
            </AntdLayout>
        </AntdLayout>
    );
}
